import styled from "@emotion/styled";

export const FooterButtonOffset = styled.span({
    margin: "0 5px",
});
